import capitalize from 'lodash/capitalize';

/**
 * Converts an underscore_string to an Capitalized String
 * @param {string} key String to convert
 */
export const snakeToCapitalized = (key) => capitalize(key.replace(/_/g, ' '));
